import type ProfileStore from "../../../../stores/ProfileStore";
import type {PpvColumns, PpvFilterColumns} from "./PpvApiClasses";
import {PPV_COLUMN_OPTIONS, PPV_FILTER_OPTIONS} from "./PpvApiClasses";

export function getPpvFilterOptions(p: ProfileStore): readonly PpvFilterColumns[] {
    const enabledColumns = getPpvColumnOptions(p);
    return PPV_FILTER_OPTIONS.filter(c => enabledColumns.includes(c));
}

export function getPpvColumnOptions(p: ProfileStore): readonly PpvColumns[] {
    return p.p.ppvConfigEnabledColumns ? p.p.ppvConfigEnabledColumns : PPV_COLUMN_OPTIONS
}

export const PPV_FILTERS_CACHED = true;

export function displayPpvVarianceKey(p: ProfileStore) {
    return `Same ${p.partDataName}`
}
